/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-04-24 15:40:41
 */
import router from './router'
import store from './store'
import { updateThemeColor, setStyle, getLightColor } from './utils/primaryColor'
import { formatDocumentTitle } from './utils/documentTitle'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'
import { PrevLoading } from './utils/loading'
// import { getSkinJson } from './api/user'
import { Storage } from '@yld/yun-utils-common'
import { Message } from 'element-ui'

// 计数器
let count = 0

// 加载 loading
PrevLoading.start()

const userInfo = store.getters.userInfo || {}

router.beforeEach(async(to, from, next) => {
  NProgress.configure({ showSpinner: false })
  NProgress.start()
  const lang = JSON.parse(localStorage.getItem('_xLang_code_giga'))
  const zh_CN = JSON.parse(localStorage.getItem('_xLang_code_zh_CN'))
  const en = JSON.parse(localStorage.getItem('_xLang_code_en'))
  let msg = null
  if (zh_CN && lang.value === 'zh_CN') {
    msg = zh_CN.value
  }
  if (en && lang.value === 'en') {
    msg = en.value
  }
  if (get(to, 'meta.title')) {
    const path = to.meta.parentPath
    // 根据当前模块路径动态替换浏览器title
    formatDocumentTitle(path, msg)
  } else {
    document.title = msg ? msg.rateMiddleOfficeMenu : '运价中台'
  }
  if (!count && isEmpty(userInfo)) {
    // 获取菜单
    let accessRoutes = []
    // 判断本地是否存储了localStorage, 分别执行SSO单端登录流程，或直接执行程序操作
    const token = await localStorage.getItem('global_auth_token')
    console.log(!token)
    if (!token) {
      await store.dispatch('permission/handleToExternalSsoLogin').then(async(res) => {
        accessRoutes = await store.dispatch('permission/getUserMenuList')
        // 获取用户信息
        store.dispatch('user/getInfo').then(response => {
        // 皮肤处理
          if (Storage.getStorage('gigaThemeStyle')) {
            const model = Storage.getStorage('gigaThemeStyle')
            setStyle(model)
            // 颜色变浅
            for (let i = 1; i <= 9; i++) {
              document.body.style.setProperty(`--el-color-primary-light-${i}`, `${getLightColor(model.primary, i / 10)}`)
            }
            updateThemeColor(model.primary)
          }
        })
      }).catch((err) => {
        console.log(err)
        Message.error(err?.msg)
        setTimeout(() => {
          Storage.clearStorage()
          // 测试环境
          // window && window.location.replace('http://test-iam.sdlandsea.net/#/passport/logout?client_id=1180946496460161024&response_type=code&redirect_uri=')
          // 生产环境
          window && window.location.replace('https://iam.sdland-sea.com/#/passport/logout?client_id=1180946496460161024&response_type=code&redirect_uri=https://fare.i-ebs.com')
        }, 2000)
      })
    } else {
      // localStorage.setItem('global_auth_token', 'd38440a8-6c75-4e7a-a6c2-1b2d5c5c2f8f')
      accessRoutes = await store.dispatch('permission/getUserMenuList')
      // 获取用户信息
      store.dispatch('user/getInfo').then(response => {
        // 皮肤处理
        if (Storage.getStorage('gigaThemeStyle')) {
          const model = Storage.getStorage('gigaThemeStyle')
          setStyle(model)
          // 颜色变浅
          for (let i = 1; i <= 9; i++) {
            document.body.style.setProperty(`--el-color-primary-light-${i}`, `${getLightColor(model.primary, i / 10)}`)
          }
          updateThemeColor(model.primary)
        }
      })
    }
    // 动态添加可访问路由表
    await router.addRoutes(accessRoutes)

    await count++
    next({ ...to, replace: true })
  } else {
    next()
  }
  NProgress.done()
})

router.afterEach(() => {
  NProgress.done()
  PrevLoading.done()
})
